/**
 * A reply typed into the composer while a question card is open becomes that
 * card's answer. The answer can be recorded while the run that should read it
 * fails to start (all build slots busy): the server answers 200 with a
 * `warning`. Rejecting then makes the composer put the text back, so it can be
 * sent again as an ordinary message once the card has closed.
 */
export async function submitComposerAnswer(
  answer: () => Promise<{ warning?: string } | undefined>,
  notify: { warning: (message: string) => void; error: (message: string) => void },
): Promise<void> {
  let result: { warning?: string } | undefined;
  try {
    result = await answer();
  } catch (err) {
    notify.error((err as Error).message || 'Could not send your answer');
    throw err;
  }
  if (result?.warning) {
    notify.warning(result.warning);
    throw new Error(result.warning);
  }
}
